const buttonStrings = {
  buttons: {
    ok: 'Ok',
    close: 'Close',
  },
};

export default buttonStrings;
